import React from 'react';
import CustomVideoPlayer from './components/Footprint/CustomVideoPlayer';


const Final = () => {
  // const videoOptions = {
  //   autoplay: false,
  //   controls: true,
  //   responsive: true,
  //   fluid: true,
  //   sources: [{
  //     type: 'video/mp4'
  //   }]
  // };

  const videoOptions = {
    controls: true,
    responsive: true,
    fluid: true,
    sources: [
      {
        src: 'https://www.w3schools.com/html/mov_bbb.mp4', // Replace with your video URL
        type: 'video/mp4',
      },
    ],
  };

  const timelineStickers = [
    { time: 10, content: "Important moment", color: "red" },
    { time: 25, content: "Funny part", color: "blue" },
    { time: 45, content: "Action scene", color: "yellow" }
  ];

  return (
    <div className='w-full'>
      <h1>Video with Timeline Stickers</h1>
      <CustomVideoPlayer
        videoUrl="https://footprints.testtube.io/66fe31a5e40f8c862650b0c5/6708f7be392ed6cf5278e8bc/67af42eb9f82323f4f64cf15/testcase-dynamic-1739539212922.mp4"
        errorTimestamps={[5, 12, 17, 24]} // Example error points
      />
    </div>
  );
};

export default Final;